import React, { Component } from 'react'
import {
  Button,
  ButtonToolbar
} from 'react-bootstrap'

import { BootstrapTable } from 'react-bootstrap-table'
import FontAwesome from 'react-fontawesome'
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css'

class SingleSelectTable extends Component {

  options = {
    sortName: 'id',
    sortOrder: 'desc'
  }

  constructor(props) {
    super(props)

    this.state = {
      itemSelected: false,
      selectedRow: { id: null },
      selectRowProp: {
        mode: "radio",
        clickToSelect: true,
        hideSelectColumn: true,
        bgColor: "#9bbfdd",
        onSelect: this.onRowSelect
      },
    }
  }

  onRowSelect = (row, isSelected) => {

    if(isSelected === true) {
      this.setState({ selectedRow: row })
    }
    this.setState({ itemSelected: isSelected })

    const { itemSelected } = this.props
    if (itemSelected) {
      itemSelected(row, isSelected)
    }
  }

  renderToolbar = () => {

    const { addNewLabel, addNewHandler, handleDelete, disableDelete, deleteLabel, iconName,
      shouldRenderToolbar } = this.props
    if(!shouldRenderToolbar) return null

    const { selectedRow, itemSelected } = this.state

    return (
      <ButtonToolbar className='margin-bottom-40'>
        <Button bsStyle='primary' title={ addNewLabel }
          onClick={ addNewHandler } className="min-w-120">
          <FontAwesome name='plus-circle' /> { addNewLabel }
        </Button>

        { handleDelete && disableDelete &&
        <Button bsStyle='danger' onClick={() => { handleDelete(selectedRow); this.setState({ itemSelected: false })}}
          title={ deleteLabel } className='min-w-120'
          disabled={ !itemSelected || disableDelete(selectedRow) }>
          <FontAwesome name={ iconName ? iconName : 'trash-o' } /> { deleteLabel }
        </Button>
        }
      </ButtonToolbar>
    )
  }

  renderContent = () => {

    const { items, children, exportCSV, csvFileName } = this.props,
    { selectRowProp } = this.state

    return (
      <div>

        <BootstrapTable 
          data={ items }
          striped
          hover
          condensed
          selectRow={ selectRowProp }
          options={ this.options }
          exportCSV={ exportCSV }
          csvFileName={ csvFileName }
          pagination>
          { children }
        </BootstrapTable>

        { this.renderToolbar() }
      </div>
    )
  }

  render() {
    return (
      this.props.loading ? <p>Loading...</p> : this.renderContent()
    )
  }
}

export default SingleSelectTable



// WEBPACK FOOTER //
// ./src/components/fragments/SingleSelectTable.js